export type LifecycleState = "wip" | "review" | "released" | "obsolete";

export const STATE_LABELS: Record<LifecycleState, string> = {
  wip: "WIP",
  review: "Review",
  released: "Released",
  obsolete: "Obsolete",
};

export const STATE_COLORS: Record<LifecycleState, { bg: string; fg: string }> = {
  wip: { bg: "rgba(160,160,160,0.15)", fg: "#999" },
  review: { bg: "rgba(230,180,40,0.15)", fg: "#b89a20" },
  released: { bg: "rgba(60,180,80,0.15)", fg: "#2a9d3a" },
  obsolete: { bg: "rgba(220,60,60,0.15)", fg: "#c44" },
};

export type ECOState = "draft" | "submitted" | "approved" | "implemented" | "closed";

export const ECO_STATE_LABELS: Record<ECOState, string> = {
  draft: "Draft",
  submitted: "Submitted",
  approved: "Approved",
  implemented: "Implemented",
  closed: "Closed",
};

export const ECO_STATE_COLORS: Record<ECOState, { bg: string; fg: string }> = {
  draft: { bg: "rgba(160,160,160,0.15)", fg: "#999" },
  submitted: { bg: "rgba(230,180,40,0.15)", fg: "#b89a20" },
  approved: { bg: "rgba(60,180,80,0.15)", fg: "#2a9d3a" },
  implemented: { bg: "rgba(88,166,255,0.15)", fg: "#58a6ff" },
  closed: { bg: "rgba(220,60,60,0.15)", fg: "#c44" },
};
